import App from "./App";
import AboutUs from "./pages/AboutUs";
import CalSchedule from "./pages/Cal";
import Contact from "./pages/Contact";
import ErrorPage from "./pages/ErrorPage";
import FAQ from "./pages/Faq";
import ForgotPassword from "./pages/ForgotPassword";
import Homepage from "./pages/Homepage";
import Login from "./pages/Login";
import PaymentPage from "./pages/Payment";
import Portfolio from "./pages/Portfolio";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Register from "./pages/Register";
import ResetPassword from "./pages/ResetPassword";
import Schedule from "./pages/Schedule";
import TermsOfService from "./pages/TermsOfService";
import VerifyEmail from "./pages/VerifyEmail";

const routes = [
    {
        path: "/",
        element: <App />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: "/",
                element: <Homepage />,
            },
            {
                path: "/login",
                element: <Login />,
            },
            {
                path: "/register",
                element: <Register />,
            },
            {
                path: "/verify-email/:token?",
                element: <VerifyEmail />,
            },
            {
                path: "/reset-password/:token?",
                element: <ResetPassword />,
            },
            {
                path: "/forgot-password",
                element: <ForgotPassword />,
            },
            {
                path: "/about",
                element: <AboutUs />,
            },
            {
                path: "/portfolio",
                element: <Portfolio />,
            },
            {
                path: "/contact",
                element: <Contact />,
            },
            {
                path: "/privacy-policy",
                element: <PrivacyPolicy />,
            },
            {
                path: "/terms-of-service",
                element: <TermsOfService />,
            },
            {
                path: "/faq",
                element: <FAQ />,
            },
            {
                path: "/payment",
                element: <PaymentPage />,
            },
            {
                path: "/schedule",
                element: <CalSchedule />,
            },
        ],
    },
]

export default routes;